import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { EmblaCarouselDirective, EmblaCarouselType, EmblaEventType } from 'embla-carousel-angular';

import { BaseResizableComponent } from '../base';

import { INITIAL_IMG_INDEX, CAROUSEL_OPTIONS, CAROUSEL_THUMB_OPTIONS } from './constants';

@Component({
  selector: 'app-images-carousel',
  templateUrl: './images-carousel.component.html',
  styleUrls: ['./images-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagesCarouselComponent extends BaseResizableComponent {
  @Input() imageIds: string[] = [];
  @Input() productUnionId?: string | null;

  @ViewChild(EmblaCarouselDirective) emblaRef?: EmblaCarouselDirective;
  @ViewChild('emblaThumbs', { read: EmblaCarouselDirective }) emblaThumbsRef?: EmblaCarouselDirective;

  selectedImgIndex = INITIAL_IMG_INDEX;

  private emblaApi?: EmblaCarouselType;
  private emblaThumbsApi?: EmblaCarouselType;

  readonly options = CAROUSEL_OPTIONS;
  readonly optionsThumbs = CAROUSEL_THUMB_OPTIONS;

  readonly subscribeToEvents: EmblaEventType[] = ['select'];

  ngAfterViewInit() {
    this.emblaApi = this.emblaRef?.emblaApi;
    this.emblaThumbsApi = this.emblaThumbsRef?.emblaApi;
  }

  onEmblaChange(event: EmblaEventType): void {
    if (this.emblaApi && event === 'select') {
      this.changeImageIndex(this.emblaApi.selectedScrollSnap());
    }
  }

  changeImageIndex(index: number) {
    if (this.selectedImgIndex !== index) {
      this.selectedImgIndex = index;
    }

    if (index < 0) {
      this.selectedImgIndex = this.imageIds.length - 1;
    }

    if (index > this.imageIds.length - 1) {
      this.selectedImgIndex = 0;
    }

    this.emblaApi?.scrollTo(this.selectedImgIndex);
    this.emblaThumbsApi?.scrollTo(this.selectedImgIndex);
  }

  navigate(delta: number) {
    const newIndex = this.selectedImgIndex + delta;
    this.changeImageIndex(newIndex);
  }
}
